import React, {useEffect, useState, useCallback} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import debounce from 'lodash.debounce';
import {getEntrances} from '../actions';
import {Filters, Layout, PageHeader} from '../components';
import EntrancesTab from '../components/CustomTables/EntrancesTable';
import {Box, Pagination} from '@mui/material';
import useFilters from '../utils/useFilters';

const Entrances = () => {
  const dispatch = useDispatch();
  const {entrances, entrancesLoading, entrancesPage, entrancesTotalPages} =
    useSelector(s => s.entrances);
  const filters = useFilters(val => dispatch(getEntrances(val)));

  const onPageChange = (e, value) => {
    dispatch(getEntrances({page: value, ...filters.filters}));
  };

  useEffect(() => {
    dispatch(getEntrances());
  }, []);

  return (
    <Layout>
      <PageHeader title="Entrances" />
      <Filters m="1.5rem" withSearch withBuilding {...filters} />
      <EntrancesTab
        entrances={entrances}
        loading={entrancesLoading}
        hideAddButton
      />
      {entrancesTotalPages > 1 && (
        <Box mt="1rem" display="flex" justifyContent="center">
          <Pagination
            count={entrancesTotalPages}
            page={entrancesPage}
            onChange={onPageChange}
          />
        </Box>
      )}
    </Layout>
  );
};

export default Entrances;
